// extracted by mini-css-extract-plugin
module.exports = {"container":"Quote_container__Cql_n","background":"Quote_background__kWpwy","inner":"Quote_inner__4TWcs","circle":"Quote_circle__ga3tC","content":"Quote_content__eImXM"};